/* INVOICES */
export const GET_PROFILE_DETAIL = "GET_PROFILE_DETAIL"
export const GET_PROFILE_DETAIL_SUCCESS = "GET_PROFILE_DETAIL_SUCCESS"
export const GET_PROFILE_DETAIL_FAIL = "GET_PROFILE_DETAIL_FAIL"
